import { Box } from "@mui/material";
import { InputButton } from "components/UI";
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { BUTTON_VALUE } from "shared/constants";
import { useLoadingContext } from "shared/contexts/LoadingContext";
import { useUploadingScanningDataUpdateDataMutation } from "shared/services/main-server";
import { isBlankOrNull, responseErrors, responseErrorsArr, responseSuccess } from "utils";
// -- [CR-2025-08-27] by Panisara process main server by plant -----
const PROCESS_TYPE = {
  MAIN_TO_PLANT: "1",
  PLANT_TO_MAIN: "2",
  MOVEMENT_UPLOAD: "3",
  ALL_TYPE: "ALL",
};
export default function ButtonSendingData({ form, setForm, setMsg: { setMsgError, setMsgAlert }, functionId }) {
  const { startLoading, stopLoading } = useLoadingContext();
  const userInfo = useSelector(state => state.auth.user);
  const uploadApi = useUploadingScanningDataUpdateDataMutation();
  const handleSend = async () => {
    setMsgAlert([]);
    setMsgError([]);
    try {
      // -- [CR-2025-08-27] by Panisara process main server by plant -----
      const body = {
        impExpCode: isBlankOrNull(form?.locationId) ? PROCESS_TYPE.ALL_TYPE : form?.locationId,
        dataType: form?.dataTypeId,
        // dataType: isBlankOrNull(form?.dataTypeId) ? PROCESS_TYPE.ALL_TYPE : form?.dataTypeId,
        userCompanyCd: userInfo.companyAbbr,
        userId: userInfo.userName,
      };
      startLoading();
      const response = await uploadApi(body);
      const msg = responseSuccess(response);
      stopLoading();
      setMsgAlert([msg]);
      return;
    } catch (error) {
      stopLoading();
      const err = responseErrors(error);
      setMsgError(err);
      return;
    }
  };
  const handleClear = () => {
    setMsgAlert([]);
    setMsgError([]);
    setForm({ locationId: "", dataTypeId: "" });
  };
  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          flexFlow: "row wrap",
          justifyContent: "flex-end",
          alignItems: "center",
        }}>
        <InputButton value={BUTTON_VALUE.SEND} onClick={handleSend} name={`${functionId}Send`} tabIndex={1} />
        <InputButton
          value={BUTTON_VALUE.CLEAR}
          onClick={handleClear}
          onKeyDown={e => {
            if (e.key === "Tab") {
              e.preventDefault();
              document.getElementById("dropdown-location").focus();
            }
          }}
          tabIndex={1}
          name={`${functionId}Clear`}
        />
      </Box>
    </Fragment>
  );
}
